import * as React from "react";

function Instagram2(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.3767 0.000244141H6.62299C2.97108 0.000244141 0 2.97146 0 6.62338V17.3771C0 21.0292 2.97108 24.0002 6.62299 24.0002H17.3767C21.0289 24.0002 24 21.029 24 17.3771V6.62338C24.0001 2.97146 21.0289 0.000244141 17.3767 0.000244141ZM21.8707 17.3771C21.8707 19.855 19.8548 21.8708 17.3769 21.8708H6.62299C4.14522 21.871 2.1294 19.855 2.1294 17.3771V6.62338C2.1294 4.14561 4.14522 2.12964 6.62299 2.12964H17.3767C19.8546 2.12964 21.8706 4.14561 21.8706 6.62338V17.3771H21.8707Z"
        fill="#8A8D8F"
      />
      <path
        d="M12 5.81641C8.58997 5.81641 5.8158 8.59058 5.8158 12.0006C5.8158 15.4105 8.58997 18.1845 12 18.1845C15.41 18.1845 18.1842 15.4105 18.1842 12.0006C18.1842 8.59058 15.41 5.81641 12 5.81641ZM12 16.055C9.76426 16.055 7.94519 14.2362 7.94519 12.0005C7.94519 9.76459 9.76412 7.94566 12 7.94566C14.2359 7.94566 16.0548 9.76459 16.0548 12.0005C16.0548 14.2362 14.2357 16.055 12 16.055Z"
        fill="#8A8D8F"
      />
      <path
        d="M18.4436 4.01074C18.0333 4.01074 17.6303 4.17684 17.3405 4.46785C17.0494 4.75745 16.882 5.16062 16.882 5.5723C16.882 5.98271 17.0495 6.38573 17.3405 6.67675C17.6301 6.96634 18.0333 7.13386 18.4436 7.13386C18.8553 7.13386 19.257 6.96634 19.548 6.67675C19.839 6.38573 20.0051 5.98256 20.0051 5.5723C20.0051 5.16062 19.839 4.75745 19.548 4.46785C19.2584 4.17684 18.8553 4.01074 18.4436 4.01074Z"
        fill="#8A8D8F"
      />
    </svg>
  );
}

export default Instagram2;
